import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { getFrictionlessOnboarding, setReturnUrl } from "@/hooks/useAuthPrompt";
import { isVolunteerSession, volunteerHandoff } from "@/lib/volunteerCampaign";

/** Sends a volunteer who just logged in on a public page to their onboarding. */
export function useVolunteerCampaignHandoff(): void {
  const { isAuthenticated, profileSynced, isOnboarded } = useAuth();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const next = volunteerHandoff({
      isAuthenticated,
      profileSynced,
      isOnboarded,
      isVolunteer: isVolunteerSession(),
      hasFrictionlessContext: getFrictionlessOnboarding() !== null,
      pathname,
      search,
    });
    if (!next) return;
    if (next.returnUrl) {
      try { setReturnUrl(next.returnUrl); } catch { /* storage unavailable */ }
    }
    navigate(next.to, { replace: true });
  }, [isAuthenticated, profileSynced, isOnboarded, pathname, search, navigate]);
}
